import { Divider, Typography } from "@mui/material";
import LoginHeader from "./LoginHeader";
import { TextInput } from "../../components-redesign/TextInput/TextInput";
import PrimaryButton from "../../components-redesign/StyledButtons/PrimaryButton";
import PrimaryLink from "../../components-redesign/StyledLinks/PrimaryLink";
import { useLocalTranslationState } from "../../context/AppContext/AppContext";
import { styled } from "@mui/material/styles";
import { myVJBlack200 } from "../../constants/brandingColors";
// import Utils from "../../utilities/utils";

// const SubmitButton = styled(Button)(({ theme }) => ({
//   margin: theme.spacing(1, 0, 1),
//   maxWidth: theme.spacing(20)
// }));

const FormContainer = styled("form")(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  [theme.breakpoints.down('sm')]: {
    minWidth: '100%',
  },
}));

const LoginBtnContainer = styled("div")(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-end',
  flexDirection: "column",
  paddingTop: theme.spacing(2.5),
}));

const EmptyDivContainer = styled("div")({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
});

const TextContainer = styled("div")({
  alignSelf: "flex-start",
});

const CreateAccountLinkContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignSelf: "flex-start",
  paddingTop: theme.spacing(1),
}));

interface EnterUsernameProps {
  isLoading;
  username;
  error: boolean;
  setError: (error) => void;
  setLoginState: (state) => void
  authError: string;
  setAuthError: (authError) => void;
  setUsername: (username) => void;
  onNext: (bypassSSO) => void;
}

const LoginEnterUsername = ({
  isLoading,
  username,
  setUsername,
  setError,
  setLoginState,
  authError,
  setAuthError,
  onNext,
}: EnterUsernameProps) => {
  const { _translate } = useLocalTranslationState();

  const validateEmail = (value: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  };

  const isValid = () => {
    if (username) {
      if (validateEmail(username)) {
        setError(false);
        setAuthError("")
        return true
      } else {
        setError(true);
        setAuthError(_translate("Error, please correct this field"))
        return false
      }
    } else {
      setError(true);
      setAuthError(_translate("Error, please complete this field"))
      return false
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isValid()) {
      onNext(false);
    }
  };

  return (
    <>
      <FormContainer noValidate onSubmit={handleSubmit}>
        <LoginHeader text={_translate("Log in")} />
        <EmptyDivContainer sx={(theme) => ({
          paddingBottom: theme.spacing(5)
        })} />

        <TextInput
          fieldName="email"
          id="email"
          dataTestId="email"
          label={_translate("Email address")}
          value={username}
          isDisabled={isLoading}
          isRequired={true}
          autoFocus={true}
          errorInPlainText={false}
          error={authError}
          onClear={() => setUsername('')}
          onChange={(event) => {
            const value = event.target.value;
            setUsername(() => value);
            if (value) {
              setError(false);
              setAuthError('')
            }
          }}
        />

        <LoginBtnContainer>
          <PrimaryButton
            id="login-next-btn"
            text={_translate("Continue")}
            dataTestId="next-btn"
          />
        </LoginBtnContainer>

        <EmptyDivContainer
          sx={(theme) => ({
            paddingBottom: theme.spacing(5),
            [theme.breakpoints.down('sm')]: {
              paddingBottom: theme.spacing(8),
            },
          })}
        />

        <Divider sx={{ borderColor: myVJBlack200 }} />
        <LoginBtnContainer>
          <TextContainer>
            <Typography component="h3" variant="h6" fontWeight="400">
              {_translate("Not a Connect customer yet")}
            </Typography>
          </TextContainer>
          <CreateAccountLinkContainer>
            <PrimaryLink
              text={_translate("Create an account")}
              onClick={setLoginState} />
          </CreateAccountLinkContainer>
        </LoginBtnContainer>

        {/* Uncomment if needed for SSO testing */}
        {/* {Utils.isLocalhost() && (
          <LoginBtnContainer>
            <SubmitButton
              id="noSSO-btn"
              fullWidth
              variant="contained"
              color="primary"
              className={"noSSO-btn"}
              type="submit"
              onClick={() => onNext(true)}
            >
              {"Bypass SSO (For Testing)"}
            </SubmitButton>
          </LoginBtnContainer>
        )} */}

      </FormContainer >

    </>
  );
};

export default LoginEnterUsername;